import React from 'react';
import { DashlineSeparator } from '../../../common/CommonStyle';
import {
  ImageStyle,
  ImageWrapper,
  InstructionContainer,
  ListContainer,
  Title,
  refreshBtnStyle,
} from './CameraPermissionStyle';
import { getBrowserDetails } from '../../../../utils/helpers';
import PageInfoIcon from '../../../../atoms/icons/PageInfoIcon';
import JoinActionButton from '../../JoinActionButton';
import JoinSkipButton from '../../JoinSkipButton';
import colors from '../../../../theme/colors';
import { StepDescription } from '../SelfieVerificationStyle';
import { s3BucketContentDir } from '../../../../config/Master';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const MobileInstruction: React.FC<{ isJoinFlow: boolean; handleBackButtonClick: () => void }> = ({
  isJoinFlow,
  handleBackButtonClick,
}) => {
  const { isSafari } = getBrowserDetails();

  const { isSVWallByGetSelfieVerified } = useSelector((state: RootState) => state.profile);

  return (
    <>
      <StepDescription isJoinFlow={isJoinFlow} style={{ margin: 0 }}>
        We must have camera access to continue the verification process. Please review the instructions below.
      </StepDescription>
      <DashlineSeparator style={{ width: '100%' }} />
      <InstructionContainer isJoinFlow={isJoinFlow}>
        <Title>Instructions to grant camera access</Title>
        {isSafari ? (
          <ListContainer isJoinFlow={isJoinFlow}>
            <li>Tap “AA” icon at the bottom left of the URL bar</li>
            <li>Select “Website Settings”</li>
            <li>Select “Camera” and check “Allow”</li>
            <li>Do this for “Microphone” as well</li>
            <li>Tap “Done” to save</li>
            <li>Refresh your browser</li>
          </ListContainer>
        ) : (
          <ListContainer isJoinFlow={isJoinFlow}>
            <li>
              Tap{' '}
              <span style={{ verticalAlign: 'middle' }}>
                <PageInfoIcon />
              </span>{' '}
              icon at the left side of the URL bar
            </li>
            <li>Go to “Camera” and check “Allow”</li>
            <li>Do this for “Microphone” as well</li>
            <li>Tap “Done” to save</li>
            <li>Refresh your browser</li>
          </ListContainer>
        )}
      </InstructionContainer>
      <ImageWrapper>
        <ImageStyle
          src={
            isSafari
              ? `${s3BucketContentDir}sv/iOS-instructions.png`
              : `${s3BucketContentDir}sv/grant-access-instructions.png`
          }
          alt="permission_instruction"
        />
      </ImageWrapper>
      <DashlineSeparator style={{ width: '100%' }} />
      <div style={{ textAlign: 'center' }}>
        <JoinActionButton
          label="Refresh"
          isDefault={true}
          onClick={() => {
            window.location.reload();
          }}
          customStyle={refreshBtnStyle}
        />

        <JoinSkipButton
          label={isSVWallByGetSelfieVerified ? 'Cancel' : 'Back'}
          customStyle={{ color: colors.gray['1100'] }}
          onClick={handleBackButtonClick}
        />
      </div>
    </>
  );
};

export default MobileInstruction;
